import { BAD_AUCTIONS } from 'app/features/miso/context/constants'
import { AuctionStatus, RawAuction } from 'app/features/miso/context/types'
import { useMisoHelperContract } from 'app/hooks'
import { useSingleCallResult } from 'app/state/multicall/hooks'
import { useMemo } from 'react'

interface ActionListReturn {
  auctions: RawAuction[]
  loading: boolean
}

export const useAuctionList = (type?: AuctionStatus): ActionListReturn => {
  const contract = useMisoHelperContract()
  // @ts-ignore TYPE NEEDS FIXING
  const { result, loading } = useSingleCallResult(contract, 'getMarkets', undefined) //, { gasRequired: 8_000_000 }

  return useMemo(() => {
    if (!result || !Array.isArray(result) || !(result.length > 0)) return { auctions: [], loading }

    // @ts-ignore TYPE NEEDS FIXING
    let filtered = result[0].filter((el) => !BAD_AUCTIONS.includes(el.addr))
    const currentTimestamp = new Date().getTime()

    if (type === AuctionStatus.LIVE) {
      return {
        auctions: filtered.filter(
          // @ts-ignore TYPE NEEDS FIXING
          (auction) =>
            currentTimestamp >= auction.startTime.mul('1000').toNumber() &&
            currentTimestamp < auction.endTime.mul('1000').toNumber() &&
            !auction.finalized
        ),
        loading,
      }
    } else if (type === AuctionStatus.UPCOMING) {
      return {
        auctions: filtered.filter(
          // @ts-ignore TYPE NEEDS FIXING
          (auction) => currentTimestamp < auction.startTime.mul('1000').toNumber() && !auction.finalized
        ),
        loading,
      }
    } else if (type === AuctionStatus.FINISHED) {
      return {
        auctions: filtered.filter(
          // @ts-ignore TYPE NEEDS FIXING
          (auction) => currentTimestamp > auction.endTime.mul('1000').toNumber() || auction.finalized
        ),
        loading,
      }
    }

    return { auctions: filtered || [], loading }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result, type, loading])
}
